import { StructureBuilder } from "sanity/structure";

export default (S: StructureBuilder) =>
  S.listItem()
    .title("Expedition Team")
    .schemaType("expeditionTeamMember")
    .child(S.documentTypeList("expeditionTeamMember"));
